import { ChatMessage, MateDispatchMessage } from "@/types/entity";
import { useGlobalUser } from "@/stores/globalUser";
import { IMessageItem } from "@/types/component";
import { MessageRole } from "@/enums/mission";

export const buildMsgItem = (item: ChatMessage, currentMateId: number) =>
  ({
    ...item,
    id: item.id,
    mateUuid: item.mate?.uuid,
    isCurrentUser: currentMateId === item.mate?.id,
    msg: item.text,
    mediaUrl: item.mate?.mediaUrl,
    name: item.mate?.name,
    reactions: item.dtIgnore ? ["dislike"] : [],
    mateToneId: item.mateToneId,
    mateTraitMedia: item.mateTraitMedia,
    audioUrl: item.mediaUrl,
    time: item.dtCreate,
    isPaid: item.isPaid,
    requireUnlock: item.isLocked,
    emotionMediaUrl: item.emotionMediaUrl,
    media: item.media,
    fromNames: item.fromNames,
    toNames: item.toNames,
  } as IMessageItem);

export const isLockMsg = (item: IMessageItem) =>
  item.requireUnlock === 1 && item.isPaid === 0;

export const replacePlaceHolder = (msg: string, char: string, user: string) => {
  if (!msg) return "";
  return msg
    .replaceAll("{{char}}", char)
    .replaceAll("{{user}}", user || "{{user}}");
};

export const getDefaultPersonaId = (mate: Mate) => {
  const useStore = useGlobalUser();
  if (useStore.user.subscriptionType < 3) return undefined;
  return !useStore.isHideNSFW &&
    import.meta.env.VITE_DEFAULT_PERSONA_ID &&
    mate.isAllowedInjected
    ? Number(import.meta.env.VITE_DEFAULT_PERSONA_ID)
    : undefined;
};

export const buildDispatchMsgItem = (item: MateDispatchMessage): IMessageItem =>
  ({
    id: item.id,
    mateUuid: item.mate?.uuid,
    isCurrentUser: item.role === MessageRole.User,
    msg: item.content,
    mediaUrl: item.mate?.mediaUrl,
    name: item.mate?.name,
    reactions: [],
    mateToneId: -1,
    audioUrl: "",
    mateTraitMedia: null,
    time: item.dtCreate,
    emotionMediaUrl: "",
    fromNames: "",
    toNames: "",
  } as IMessageItem);
